import React from 'react'
import FilePopUp from './FilePopUp'
import { useState } from 'react' 
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import PdfPreview from './PdfPreview';
import SessionsApi from 'Classes/API/Administration/SessionsApi';

const EntryFile = ({entry}) => {
    const [ShowFile, setShowFile] = useState(false)
    const getFileDiv = (entry) => {
        if (entry.fileUrl != null) {
            return (
                <div style={{ border: '1px solid #0000001c', textAlign: "center" }}>
                    {
                        getFileElement(entry, true)
                    }
                </div>
            )
        }
        else if (entry.getEntryFiles.length > 0) {
            return entry.getEntryFiles.map((file) => (
                <div key={file.id} style={{ border: '1px solid #0000001c', textAlign: "center" }}>
                    {
                        getFileElement(file, false)
                    }
                </div>
            ))
        }
        else {
            return <div></div>
        }
    }

    const getFileElement = (file, isCloud) => {
        if(isCloud){
            if(file.fileType == null || file.fileType.startsWith('image/')){
                return (
                    <div style={{ border: '1px solid #0000001c', textAlign: "center" }}  onClick={() => setShowFile(true)}>
                        <img
                            src={file.fileUrl}
                            style={{ maxWidth: '100%', maxHeight: '300px', marginBottom: '10px' }}
                        />
                    </div>
                )
            }
            else if(file.fileType.startsWith('video/')){
                return (
                    <div key={file.id} style={{ border: '1px solid #0000001c', textAlign: "center" }}  onClick={() => setShowFile(true)}>
                        <video
                            src={file.fileUrl}
                            controls
                            style={{ maxWidth: '100%', maxHeight: '300px', marginBottom: '10px' }}
                        />
                    </div>
                )
            }
            //pdf
            else if(file.fileType.startsWith('application/pdf')){
                return (
                    <div key={file.id} style={{textAlign: "center" }}>
                        <div style={{ textAlign: "center" }}  onClick={() => setShowFile(true)}>
                            <PdfPreview fileUrl={file.fileUrl} />
                        </div>
                        <MDTypography variant="body2" mb={1}><strong>File:</strong> {file.fileName}</MDTypography>
                       
                        <MDButton color="dark" variant="outlined" style={{marginBottom: '10px'}}
                            onClick={() => {
                                window.open(file.fileUrl, '_blank');
                            }}
                            fontWeight="medium"
                        >
                            Open in Another Tab
                        </MDButton>

                    </div>
                )
            }
            else{
                return (
                    <div key={file.id} style={{ border: '1px solid #0000001c', textAlign: "center" }}>
                        <MDTypography variant="body2" mb={1}><strong>File:</strong> {file.fileName}</MDTypography>
                        <MDButton
                            onClick={() => {
                                DownloadFileClick(file.id, file.fileName);
                            }}
                            fontWeight="medium"
                        >
                            Download
                        </MDButton>
                    </div>
                )
            }  
        }
        else{
            if (file.fileType.startsWith('image/')) {
                return (
                    <div style={{ border: '1px solid #0000001c', textAlign: "center" }}  onClick={() => setShowFile(true)}>
                        <img
                            src={"data:image/png;base64," + file.file}
                            alt={file.fileName}
                            style={{ maxWidth: '100%', maxHeight: '300px', marginBottom: '10px' }}
                        />
                    </div>
                )
            } 
            else if (file.fileType.startsWith('video/')) {
                return (
                    <div key={file.id} style={{ border: '1px solid #0000001c', textAlign: "center" }} onClick={() => setShowFile(true)}>
                        <video
                            src={"data:video/mp4;base64," + file.file}
                            style={{ maxWidth: '100%', maxHeight: '300px', marginBottom: '10px' }}
                        />
                    </div>
                )
            }
            else {
                return (
                    <div key={file.id} style={{ border: '1px solid #0000001c', textAlign: "center" }}>
                        <MDTypography variant="body2" mb={1}><strong>File:</strong> {file.fileName}</MDTypography>
                        <MDButton
                            onClick={() => {
                                DownloadFileClick(file.id, file.fileName);
                            }}
                            fontWeight="medium"
                        >
                            Download
                        </MDButton>
                    </div>
                )
            }
        }
    }

    const DownloadFileClick = async (FileId, FileName) => {
        let req = {
            SearchInt: FileId
        };

        var res = await SessionsApi.DownloadHistoryFile(req);

        var csvURL = window.URL.createObjectURL(res);
        let tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', FileName);
        tempLink.click();

    }
 
    return (
        <>
            <div>

            {getFileDiv(entry)}
            </div>
            <FilePopUp entry={entry} setShowFile={setShowFile} ShowFile={ShowFile} />
        </>
    )
}

export default EntryFile